import React from 'react';
import { GraduationCapIcon, AwardIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { committeeCraft, education, civicRoles } from '../data/civic';
const section = sections[8];
export function GovernanceEducation() {
  return <div data-id="element-189" data-mp="av159c44rnrk">
      <PageHeader section={section} intro="Committee-level board experience, formal qualifications and the honorary and civic appointments held alongside commercial work." data-id="element-190" data-mp="avjdl742hsfu" />

      <section className="mt-12" aria-labelledby="committees" data-id="element-191" data-mp="13jyi2zpkoscx">
        <h2 id="committees" className="font-serif text-2xl leading-tight text-navy" data-id="element-192" data-mp="yrx85kfvndq2">
          Board committee experience
        </h2>
        <table className="mt-6 w-full border border-slate-200 bg-white text-left" data-id="element-193" data-mp="tsatd6kehpf5">
          <caption className="sr-only" data-id="element-194" data-mp="1r8rd8tydew6h">
            Committees served, role held and area of focus
          </caption>
          <thead data-id="element-195" data-mp="1mgzmojf7sqgc">
            <tr className="bg-navy" data-id="element-196" data-mp="1mggg1yv0lohm">
              <th scope="col" className="px-6 py-4 text-[10px] font-semibold uppercase tracking-overline text-gold" data-id="element-197" data-mp="23ixe56fknv47">
                Committee
              </th>
              <th scope="col" className="hidden px-6 py-4 text-[10px] font-semibold uppercase tracking-overline text-gold sm:table-cell" data-id="element-198" data-mp="1ttduhyk1bx8a">
                Role
              </th>
              <th scope="col" className="px-6 py-4 text-[10px] font-semibold uppercase tracking-overline text-gold" data-id="element-199" data-mp="1jtwoth4s9jcb">
                Focus
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200" data-id="element-200" data-mp="1aw2rq3z72lo3">
            {committeeCraft.map(item => <tr key={item.committee} className="align-top" data-id="element-201" data-mp="1fuxn05ecm2p3">
                <th scope="row" className="px-6 py-5 font-serif text-base font-normal leading-snug text-navy" data-id="element-202" data-mp="359c6obaiezdq">
                  {item.committee}
                  <span className="mt-1 block text-[11px] font-sans font-semibold uppercase tracking-widest text-gold-dark sm:hidden" data-id="element-203" data-mp="37t8ml0xn2sr8">
                    {item.role}
                  </span>
                </th>
                <td className="hidden whitespace-nowrap px-6 py-5 text-[13px] font-semibold text-slateink sm:table-cell" data-id="element-204" data-mp="2ys0yfbou78av">
                  {item.role}
                </td>
                <td className="px-6 py-5 text-[13px] leading-relaxed text-slateink" data-id="element-205" data-mp="3rfenyoq7h1ky">
                  {item.focus}
                </td>
              </tr>)}
          </tbody>
        </table>
      </section>

      <div className="mt-16 grid gap-14 lg:grid-cols-2 lg:gap-16" data-id="element-206" data-mp="3hp23sxmazafc">
        <section aria-labelledby="education" data-id="element-207" data-mp="3csbquj5souy5">
          <div className="flex items-center gap-3" data-id="element-208" data-mp="3cpfrqri7o084">
            <GraduationCapIcon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-209" data-mp="e1tdlabo5tx2" />
            <h2 id="education" className="font-serif text-2xl leading-tight text-navy" data-id="element-210" data-mp="998oun7me70e">
              Education &amp; development
            </h2>
          </div>
          <ul className="mt-6 divide-y divide-slate-200 border border-slate-200 bg-white" data-id="element-211" data-mp="llkrsokwlf5n">
            {education.map(item => <li key={item.qualification} className="px-6 py-5" data-id="element-212" data-mp="vj8pnndt32s1">
                <h3 className="font-serif text-lg leading-snug text-navy" data-id="element-213" data-mp="vkthh58qk7m7">
                  {item.qualification}
                </h3>
                <p className="mt-1.5 text-[13px] text-slateink" data-id="element-214" data-mp="14jx2wfvdkz3v">
                  {item.institution}
                </p>
                <p className="mt-2 text-[11px] uppercase tracking-overline text-slateink-light" data-id="element-215" data-mp="19a3soj1mipnp">
                  {item.period}
                </p>
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="civic" data-id="element-216" data-mp="1j9um0heg6ym7">
          <div className="flex items-center gap-3" data-id="element-217" data-mp="1j6qbl2ae36n3">
            <AwardIcon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-218" data-mp="1n9muyv7r76s3" />
            <h2 id="civic" className="font-serif text-2xl leading-tight text-navy" data-id="element-219" data-mp="2kz17b4iza9h5">
              Civic &amp; honorary leadership
            </h2>
          </div>
          <ul className="mt-6 space-y-px border border-slate-200 bg-slate-200" data-id="element-220" data-mp="2fy3u76cts5mi">
            {civicRoles.map(item => <li key={item.title} className="bg-white px-6 py-5" data-id="element-221" data-mp="2ppzpyarfvjnk">
                <h3 className="font-serif text-lg leading-snug text-navy" data-id="element-222" data-mp="2pqt0znxfkvbi">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-overline text-gold-dark" data-id="element-223" data-mp="1x1c2q9n4qk7d">
                  {item.organisation}
                </p>
                <p className="mt-3 text-[13px] leading-relaxed text-slateink" data-id="element-224" data-mp="2b2eqcqtrw2ke">
                  {item.detail}
                </p>
              </li>)}
          </ul>
        </section>
      </div>
    </div>;
}